import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { batchConfirmBillings } from '../api/parking-billing.ts';
import { BatchConfirmParkingBillingRequest } from '../api/requests/batch-confirm-parking-billing-request.ts';
import { BatchConfirmParkingBillingResponse } from '../api/responses/batch-confirm-parking-billing-response.ts';

export default function useBatchConfirmParkingBillingBillings(): UseMutationResult<
  BatchConfirmParkingBillingResponse[],
  Error,
  string[]
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (ids: string[]) => {
      const billings = ids.map((x) => ({ id: x }));
      const request: BatchConfirmParkingBillingRequest = { billings: billings };

      return batchConfirmBillings(request);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['unconfirmedBillings'] });
      queryClient.invalidateQueries({ queryKey: ['confirmedBillings'] });
    },
  });
}
